import { useState, useCallback } from 'react';
import { notification } from 'antd';

export const useApi = () => {
  const [loading, setLoading] = useState(false);

  const execute = useCallback(async (apiCall, options = {}) => {
    const { successMessage, errorMessage, onSuccess } = options;
    setLoading(true);
    try {
      const result = await apiCall();
      if (successMessage) {
        notification.success({ message: successMessage });
      }
      if (onSuccess) {
        onSuccess(result.data);
      }
      return result.data;
    } catch (error) {
      const message =
        error.response?.data?.message || errorMessage || 'Произошла ошибка';
      notification.error({ message });
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, execute };
};
